<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';

import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import KvkBedrijfSelect from '@shared/form/KvkBedrijfSelect/KvkBedrijfSelect.vue';
import {
  isDisabledInjectionKey,
  isReadonlyInjectionKey,
  hideRequiredAsteriskInjectionKey,
} from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const { value: hideRequiredAsteriskParent } = inject(hideRequiredAsteriskInjectionKey, {
  value: ref(false),
});

const { value: kvkNummerValue, errors: kvkNummerErrors } = useField(
  'kvknummer',
  toTypedSchema(z.string().min(1, 'Er moet een KVK-nummer gekozen zijn')),
);
</script>

<template>
  <FieldRowV2
    :errors="kvkNummerErrors"
    label="KVK-gegevens"
    label-for="relatiegegevens-relatie-kvknummer"
    :required="!hideRequiredAsteriskParent && !hasReadonlyParent"
    v-bind="$attrs"
  >
    <KvkBedrijfSelect
      v-model:kvk-nummer="kvkNummerValue"
      placeholder="Zoek op bedrijfsnaam of KVK-nummer"
      id="relatiegegevens-relatie-kvknummer"
      class="w-full"
      :disabled="hasDisabledParent"
      :readonly="hasReadonlyParent"
    />
  </FieldRowV2>
</template>
